import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import dropRight from 'lodash/dropRight';
import find from 'lodash/find';
import {
  getClaimsProcess,
  saveIsClaimsDeviceMailedOut,
} from '../../store/actions';
import Spinner from 'shared/lib/components/Spinner';
import VERTICALS from 'shared/lib/constants/verticals';
import * as analytics from 'shared/lib/analytics';

import ClaimsContact from '../../components/ClaimsContact';
import ClaimsMethods from '../../components/ClaimsMethods';

import './ClaimsPolicy.css';

const VIEWS = {
  LOADING: 'LOADING',
  CONTACT: 'CONTACT',
  METHODS: 'METHODS',
};

class ClaimsPolicy extends Component {
  state = {
    view: VIEWS.LOADING,
  };

  componentDidMount() {
    document.title = `Claims | #${this.order.policy_number} - Sure`;
    analytics.track('Portal - Claim Get Process', {
      category: 'claim',
      label: this.order.vertical_code,
      nonInteraction: 1,
    });
    this.props
      .getClaimsProcess(this.order.policy_number)
      .then(() => {
        analytics.track('Portal - Claim Get Process Success', {
          category: 'claim',
          label: this.order.vertical_code,
          nonInteraction: 1,
        });
        if (
          process.env.REACT_APP_IS_SMARTPHONE_CLAIMS_ENABLED &&
          this.order.vertical_code === 'devices'
        ) {
          this.setState({ view: VIEWS.METHODS });
        } else {
          this.setState({ view: VIEWS.CONTACT });
        }
      })
      .catch(() => {
        analytics.track('Portal - Claim Get Process Failure', {
          category: 'claim',
          label: this.order.vertical_code,
          nonInteraction: 1,
        });
        this.setState({ view: VIEWS.CONTACT });
      });
  }

  get order() {
    return find(this.props.policiesById, {
      policy_number: this.props.params.policyNumber,
    });
  }

  get verticalTitle() {
    let { description: title } = VERTICALS[this.props.params.verticalCode];
    return dropRight(title.split(' ')).join(' ');
  }

  get loadingStateNode() {
    return (
      <div className="ClaimsPolicy">
        <div className="Container Container--small">
          <h1 className="ClaimsPolicy-heading">{this.verticalTitle} Claims</h1>
          <Spinner />
        </div>
      </div>
    );
  }

  render() {
    switch (this.state.view) {
      case VIEWS.LOADING:
        return this.loadingStateNode;
      case VIEWS.CONTACT:
        return (
          <ClaimsContact
            params={this.props.params}
            orders={this.props.policiesById}
            phoneNumber={
              this.props.claimsProcessInstructions.support_phone_number
            }
          />
        );
      case VIEWS.METHODS:
        return (
          <ClaimsMethods
            order={this.order}
            params={this.props.params}
            saveIsClaimsDeviceMailedOut={this.props.saveIsClaimsDeviceMailedOut}
          />
        );
      default:
        return <h1>Something went wrong...</h1>;
    }
  }
}

const mapStateToProps = state => {
  return {
    claimsProcessInstructions: state.claimsProcessInstructions,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClaimsProcess: policyNumber => dispatch(getClaimsProcess(policyNumber)),
    saveIsClaimsDeviceMailedOut: isDeviceMailedOut =>
      dispatch(saveIsClaimsDeviceMailedOut(isDeviceMailedOut)),
    navTo: route => dispatch(push(route)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ClaimsPolicy));
